import {NavigationWrapper} from "./topNavigation.style";
import avatarImage from "../../../assets/images/Rectangle.png"
import React, {useContext, useEffect} from "react";
import {Link, useLocation} from "react-router";
import {CustomHelper} from "../../../helpers";
import {IconButtonComponent} from "../../button/iconButton.component";
import {useTheme} from "styled-components";
import {ThemeContext} from "../../../providers/theme.provider";
import {AuthContext} from "../../../providers/authentication.provider";
import userAvatarImage from "assets/images/user.png"

export const TopNavigationComponent = ({setNavWrapState}: {
    setNavWrapState: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const {mode, toggleTheme} = useContext(ThemeContext)!
    const {customerInfo} = useContext(AuthContext)!

    const toggle = () => {
        setNavWrapState(prevState => {
            localStorage.setItem("sideNavConfig", String(!prevState))
            return !prevState;
        });
    }
    let urlLastSegment = window.location.pathname.split("/").filter(Boolean)[0]
    const pathname = useLocation().pathname;
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        urlLastSegment = window.location.pathname.split("/").filter(Boolean)[0];
    }, [pathname])

    return (<NavigationWrapper className={`${!urlLastSegment ? "in-home" : ""}`}>
        <div className={"user-title"}>
            <div onClick={toggle} className={"hamburger"}>
                <svg style={{fontSize: "25px"}} width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
                        fill="currentColor"/>
                    <path
                        d="M21 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H21C21.41 11.25 21.75 11.59 21.75 12C21.75 12.41 21.41 12.75 21 12.75Z"
                        fill="currentColor"/>
                    <path
                        d="M21 17.75H3C2.59 17.75 2.25 17.41 2.25 17C2.25 16.59 2.59 16.25 3 16.25H21C21.41 16.25 21.75 16.59 21.75 17C21.75 17.41 21.41 17.75 21 17.75Z"
                        fill="currentColor"/>
                </svg>
            </div>
            <div>
                <span className={"greetings grotesk-fnt"}>{!urlLastSegment ?
                    <span style={{fontSize: "inherit"}}><span className={"greeting"}
                                                              style={{fontSize: "inherit"}}>Hello,</span> {(customerInfo?.user?.full_name || "User").split(" ")[0]}👋</span> : CustomHelper.capitalizeFirstWord(urlLastSegment.replace("-", " "))}</span>
                {!urlLastSegment &&
                    <>
                        <span className={"intro"}>What bill would you like to pay today?</span>
                        <span className={"intro short"}>Welcome back</span>
                    </>
                }
            </div>
        </div>
        <div className={"nav-icons"}>
            <IconButtonComponent onClick={toggleTheme} size={"md"} variant={"outline"}
                                 className={"rd-icon display-laptop"} id={"theme-icon"}>
                {mode=== "light" ?
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21.5302 15.93C21.3702 15.66 20.9202 15.24 19.8002 15.44C19.1802 15.55 18.5502 15.6 17.9202 15.57C15.5902 15.47 13.4802 14.4 12.0102 12.75C10.7102 11.3 9.9102 9.40999 9.9002 7.36999C9.9002 6.22999 10.1202 5.12999 10.5702 4.08999C11.0102 3.07999 10.7002 2.54999 10.4802 2.32999C10.2502 2.09999 9.7102 1.77999 8.6502 2.21999C4.5602 3.93999 2.0302 8.03999 2.3302 12.43C2.6302 16.56 5.5302 20.09 9.3702 21.42C10.2902 21.74 11.2602 21.93 12.2602 21.97C12.4202 21.98 12.5802 21.99 12.7402 21.99C16.0902 21.99 19.2302 20.41 21.2102 17.72C21.8802 16.79 21.7002 16.2 21.5302 15.93Z"
                            fill="currentColor"/>
                    </svg> :
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z" fill="currentColor"/>
                        <path d="M12 22.96C11.45 22.96 11 22.55 11 22V21.92C11 21.37 11.45 20.92 12 20.92C12.55 20.92 13 21.37 13 21.92C13 22.47 12.55 22.96 12 22.96ZM19.14 20.14C18.88 20.14 18.63 20.04 18.43 19.85L18.3 19.72C17.91 19.33 17.91 18.7 18.3 18.31C18.69 17.92 19.32 17.92 19.71 18.31L19.84 18.44C20.23 18.83 20.23 19.46 19.84 19.85C19.65 20.04 19.4 20.14 19.14 20.14ZM4.86 20.14C4.6 20.14 4.35 20.04 4.15 19.85C3.76 19.46 3.76 18.83 4.15 18.44L4.28 18.31C4.67 17.92 5.3 17.92 5.69 18.31C6.08 18.7 6.08 19.33 5.69 19.72L5.56 19.85C5.37 20.04 5.11 20.14 4.86 20.14ZM22 13H21.92C21.37 13 20.92 12.55 20.92 12C20.92 11.45 21.37 11 21.92 11C22.47 11 22.96 11.45 22.96 12C22.96 12.55 22.55 13 22 13ZM2.08 13H2C1.45 13 1 12.55 1 12C1 11.45 1.45 11 2 11C2.55 11 3.04 11.45 3.04 12C3.04 12.55 2.63 13 2.08 13ZM19.01 5.99C18.75 5.99 18.5 5.89 18.3 5.7C17.91 5.31 17.91 4.68 18.3 4.29L18.43 4.16C18.82 3.77 19.45 3.77 19.84 4.16C20.23 4.55 20.23 5.18 19.84 5.57L19.71 5.7C19.52 5.89 19.27 5.99 19.01 5.99ZM4.99 5.99C4.73 5.99 4.48 5.89 4.28 5.7L4.15 5.56C3.76 5.17 3.76 4.54 4.15 4.15C4.54 3.76 5.17 3.76 5.56 4.15L5.69 4.28C6.08 4.67 6.08 5.3 5.69 5.69C5.5 5.89 5.24 5.99 4.99 5.99ZM12 3.04C11.45 3.04 11 2.63 11 2.08V2C11 1.45 11.45 1 12 1C12.55 1 13 1.45 13 2C13 2.55 12.55 3.04 12 3.04Z" fill="currentColor"/>
                    </svg>
                }
            </IconButtonComponent>
            <IconButtonComponent size={"md"} variant={"outline"} className={"rd-icon notification"}
                                 id={"notification-icon"}>
                <svg style={{position: "relative"}} width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.52992 14.7696C2.31727 16.1636 3.268 17.1312 4.43205 17.6134C8.89481 19.4622 15.1052 19.4622 19.5679 17.6134C20.732 17.1312 21.6827 16.1636 21.4701 14.7696C21.3394 13.9129 20.6932 13.1995 20.2144 12.5029C19.5873 11.5793 19.525 10.5718 19.5249 9.5C19.5249 5.35786 16.1559 2 12 2C7.84413 2 4.47513 5.35786 4.47513 9.5C4.47503 10.5718 4.41272 11.5793 3.78561 12.5029C3.30684 13.1995 2.66061 13.9129 2.52992 14.7696Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 19C8.45849 20.7252 10.0755 22 12 22C13.9245 22 15.5415 20.7252 16 19"
                          stroke="currentColor"
                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <span style={{
                        position: "absolute",
                        background: "red",
                        fontSize: 11,
                        backgroundColor: "red",
                        padding: 4,
                        borderRadius: "100%",
                        top: 0,
                        right: 0
                    }}>12</span>

                </svg>
            </IconButtonComponent>
            <IconButtonComponent to={"/settings"} component={Link} size={"md"} variant={"outline"}
                                 className={"rd-icon display-tablet"} id={"settings-icon"}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round"/>
                    <path
                        d="M2 12.88V11.12C2 10.08 2.85 9.22 3.9 9.22C5.71 9.22 6.45 7.94 5.54 6.37C5.02 5.47 5.33 4.3 6.24 3.78L7.97 2.79C8.76 2.32 9.78 2.6 10.25 3.39L10.36 3.58C11.26 5.15 12.74 5.15 13.65 3.58L13.76 3.39C14.23 2.6 15.25 2.32 16.04 2.79L17.77 3.78C18.68 4.3 18.99 5.47 18.47 6.37C17.56 7.94 18.3 9.22 20.11 9.22C21.15 9.22 22.01 10.07 22.01 11.12V12.88C22.01 13.92 21.16 14.78 20.11 14.78C18.3 14.78 17.56 16.06 18.47 17.63C18.99 18.54 18.68 19.7 17.77 20.22L16.04 21.21C15.25 21.68 14.23 21.4 13.76 20.61L13.65 20.42C12.75 18.85 11.27 18.85 10.36 20.42L10.25 20.61C9.78 21.4 8.76 21.68 7.97 21.21L6.24 20.22C5.33 19.7 5.02 18.53 5.54 17.63C6.45 16.06 5.71 14.78 3.9 14.78C2.85 14.78 2 13.92 2 12.88Z"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
            </IconButtonComponent>
            <div>
                <img className={"me-2"} width={40} height={40}
                     src={
                         customerInfo?.profile?.profile_image
                             ? `${process.env.REACT_APP_RHOMBU_BACKEND_URL}${customerInfo.profile.profile_image}`
                             : userAvatarImage
                     }
                     alt=""/>
                <span className={"line-clamp-1 max-w-[200px] "}>
                    {customerInfo?.user?.full_name}
                </span>
            </div>
        </div>
    </NavigationWrapper>)
}